import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { cardHover } from 'src/theme/customEffects'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    
    // ----------------------------------------------
    // Card

    cardMedia: {
      aspectRatio: 'var(--product-preview-image-ratio, 16 / 9)',
      height: 'var(--product-preview-image-height, auto)',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      padding: theme.spacing(2.2, 2.25, .9),
      position: 'relative',
      backgroundColor: '#fff',

      '& img': {
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        objectPosition: 'center',
        display: 'block',
      },
    },

    cardColumn: {
      height: '100%',
      gridColumn: 'span 12',
      minWidth: 0,
      position: 'relative',
      width: '100%',
      '@media (max-width: 767px)': {
        gridColumn: 'auto / span 1 !important',
        maxWidth: '100%',
        minWidth: 0,
        width: '100%',
      },
      [theme.breakpoints.up('sm')]: { gridColumn: 'span 6' },
      [theme.breakpoints.up('md')]: { gridColumn: 'span 4' },
      [theme.breakpoints.up('lg')]: { gridColumn: 'span 3' },
    },

    wishlistButton: {
      position: 'absolute',
      right: theme.spacing(2.1),
      top: theme.spacing(2.1),
      zIndex: 2,
      minWidth: 0,
      width: 44,
      height: 44,
      borderRadius: '50%',
      color: theme.palette.text.primary,
      backgroundColor: 'rgba(255, 255, 255, .94)',
      boxShadow: '0 10px 22px rgba(15, 23, 42, .12)',
      '&:hover': {
        backgroundColor: '#fff',
      },
    },

    availabilityFlag: {
      borderRadius: '0 999px 999px 0',
      boxShadow: '0 8px 18px rgba(15, 23, 42, .12)',
      color: '#fff',
      display: 'inline-flex',
      fontSize: '.82rem',
      fontWeight: 900,
      left: 0,
      letterSpacing: 0,
      lineHeight: 1,
      maxWidth: 'calc(100% - 18px)',
      overflow: 'hidden',
      padding: theme.spacing(.58, 1.05, .58, .82),
      position: 'absolute',
      textOverflow: 'ellipsis',
      top: theme.spacing(1),
      whiteSpace: 'nowrap',
      zIndex: 2,
    },
    availabilityFlagSuccess: {
      backgroundColor: '#1f8f52',
    },
    availabilityFlagInfo: {
      backgroundColor: '#246f9c',
    },
    availabilityFlagWarning: {
      backgroundColor: '#a86413',
    },
    availabilityFlagBelowCoupon: {
      top: theme.spacing(4.1),
    },
    quantityDiscountFlag: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '0 999px 999px 0',
      boxShadow: '0 8px 18px rgba(15, 23, 42, .12)',
      color: theme.palette.primary.contrastText,
      display: 'inline-flex',
      fontSize: '.78rem',
      fontWeight: 900,
      left: 0,
      letterSpacing: 0,
      lineHeight: 1,
      maxWidth: 'calc(100% - 18px)',
      overflow: 'hidden',
      padding: theme.spacing(.52, .98, .52, .78),
      position: 'absolute',
      textOverflow: 'ellipsis',
      top: theme.spacing(1),
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      zIndex: 2,
    },
    quantityDiscountFlagBelowAvailability: {
      top: theme.spacing(4),
    },
    quantityDiscountFlagBelowCoupon: {
      top: theme.spacing(4.15),
    },
    quantityDiscountFlagBelowCouponAndAvailability: {
      top: theme.spacing(7),
    },
    couponPromotionBadge: {
      alignItems: 'center',
      borderRadius: '6px 6px 0 0',
      boxShadow: '0 8px 18px rgba(15, 23, 42, .12)',
      color: '#fff',
      display: 'inline-flex',
      fontSize: '.76rem',
      fontWeight: 900,
      justifyContent: 'center',
      left: 0,
      letterSpacing: 0,
      lineHeight: 1.05,
      maxWidth: '100%',
      overflow: 'hidden',
      padding: theme.spacing(.58, 1),
      position: 'absolute',
      textOverflow: 'ellipsis',
      top: 0,
      whiteSpace: 'nowrap',
      width: '100%',
      zIndex: 2,
    },
    couponPromotionBadgeGreen: {
      backgroundColor: '#15803d',
    },
    couponPromotionBadgeRed: {
      backgroundColor: '#b91c1c',
    },
    couponPromotionBadgeBlack: {
      backgroundColor: '#111827',
    },

    href: {
      color: 'inherit',
      textDecoration: 'inherit',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      maxWidth: '100%',
      minHeight: 0,
      minWidth: 0,
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
      borderRadius: 8,
      border: '1px solid rgba(15, 23, 42, 0.08)',
      boxShadow: '0 1px 3px rgba(15, 23, 42, 0.14)',
      overflow: 'hidden',

      '&.hover': cardHover(theme),
    },
    cardInStock: {
      borderColor: 'rgba(22, 163, 74, 0.42)',
      boxShadow: '0 10px 24px rgba(22, 163, 74, 0.12)',
    },
    cardContent: {
      flexGrow: 1,
      padding: theme.spacing(.85, 2.25, 1.05),

      '& .card-product-title ul': {
        color: theme.palette.text.primary,
        margin: theme.spacing(1.15, 0, 0),
        paddingLeft: 24,
        '& li': {
          marginBottom: theme.spacing(.25),
          paddingLeft: theme.spacing(.35),
        },
      },
      '& .card-product-title .MuiTypography-root': {
        color: theme.palette.text.primary,
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.34,
      },
      '& $productBrand': {
        color: theme.palette.text.secondary,
        display: 'block',
        fontSize: '.74rem',
        fontWeight: 900,
        letterSpacing: '.06em',
        lineHeight: 1.05,
        marginBottom: theme.spacing(.15),
        textTransform: 'uppercase',
      },
      '& $productName': {
        color: theme.palette.text.primary,
        display: 'block',
        fontSize: '1.02rem',
        fontWeight: 600,
        letterSpacing: 0,
        lineHeight: 1.22,
      },
      '& .card-product-hook': {
        color: theme.palette.text.secondary,
        fontSize: '.92rem',
        fontWeight: 600,
        lineHeight: 1.35,
        marginTop: theme.spacing(1),
      },
    },
    cardContentCompact: {
      padding: theme.spacing(1.5),
      '& $productName': {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        minHeight: 0,
      },
      '& .card-product-title ul': {
        margin: theme.spacing(.5, 0, 0),
        paddingLeft: 20,
      },
    },

    mobileEditorialProduct: {
      '& $deliverytimeDisplay': {
        display: 'none',
      },
      '& $cardContent': {
        textAlign: 'center',
      },
      '& .card-product-title': {
        textAlign: 'center',
      },
      '& .card-product-title ul': {
        display: 'inline-block',
        listStylePosition: 'outside',
        marginLeft: 'auto',
        marginRight: 'auto',
        minHeight: '1.65em',
        textAlign: 'left',
      },
      '& $cardMedia img': {
        height: '96% !important',
        maxHeight: '96% !important',
        maxWidth: '96% !important',
        objectFit: 'contain !important',
        padding: '0 !important',
        width: '96% !important',
      },
      '& $productBrand': {
        fontWeight: '900 !important',
        minHeight: '1.05em',
        textAlign: 'center',
      },
      '& $productName': {
        display: '-webkit-box',
        minHeight: '2.44em',
        overflow: 'hidden',
        textAlign: 'center',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
      },
      '& $listingGroupControls': {
        flexWrap: 'nowrap',
        justifyContent: 'center',
        overflow: 'hidden',
      },
      '& $price': {
        justifyContent: 'center',
        textAlign: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        gridColumn: 'auto / span 1 !important',
        minWidth: 0,
        '& $wishlistButton': {
          display: 'none',
        },
        '& $card': {
          backgroundColor: 'transparent !important',
          border: 0,
          borderRadius: 0,
          boxShadow: 'none',
          maxWidth: '100%',
          minWidth: 0,
          overflow: 'visible',
          width: '100%',
        },
        '& $href': {
          gap: theme.spacing(0),
          maxWidth: '100%',
          width: '100%',
        },
        '& $variantImageFrame': {
          backgroundColor: 'transparent',
          borderBottom: 0,
          maxWidth: '100%',
          marginBottom: theme.spacing(1.05),
          overflow: 'visible',
          width: '100%',
        },
        '& $variantSwipeHint': {
          backgroundColor: 'rgba(255, 255, 255, .9)',
          height: 28,
          top: '43%',
          width: 28,
        },
        '& $variantSwipeHintLeft': {
          left: theme.spacing(.35),
        },
        '& $variantSwipeHintRight': {
          right: theme.spacing(.35),
        },
        '& $cardMedia': {
          aspectRatio: '1 / 1 !important',
          backgroundColor: '#fff',
          boxSizing: 'border-box',
          height: 'auto !important',
          maxWidth: '100%',
          overflow: 'hidden',
          padding: 0,
          width: '100%',
        },
        '& $cardMedia img': {
          height: '96% !important',
          maxHeight: '96% !important',
          maxWidth: '96% !important',
          objectFit: 'contain !important',
          padding: '0 !important',
          width: '96% !important',
        },
        '& $availabilityFlag': {
          fontSize: '.72rem',
          maxWidth: 'calc(100% - 12px)',
          padding: theme.spacing(.5, .82, .5, .62),
          top: theme.spacing(.25),
        },
        '& $availabilityFlagBelowCoupon': {
          top: theme.spacing(2.95),
        },
        '& $quantityDiscountFlag': {
          fontSize: '.68rem',
          maxWidth: 'calc(100% - 12px)',
          padding: theme.spacing(.42, .72, .42, .56),
          top: theme.spacing(.25),
        },
        '& $quantityDiscountFlagBelowAvailability': {
          top: theme.spacing(2.6),
        },
        '& $quantityDiscountFlagBelowCoupon': {
          top: theme.spacing(3.05),
        },
        '& $quantityDiscountFlagBelowCouponAndAvailability': {
          top: theme.spacing(5.35),
        },
        '& $couponPromotionBadge': {
          borderRadius: '4px 4px 0 0',
          fontSize: '.68rem',
          maxWidth: '100%',
          padding: theme.spacing(.42, .6),
          top: 0,
          width: '100%',
        },
        '& $cardContent': {
          flexGrow: 0,
          padding: 0,
        },
        '& $cardContentCompact': {
          padding: 0,
        },
        '& $productBrand': {
          color: theme.palette.text.secondary,
          display: 'block',
          fontSize: '.64rem',
          fontWeight: '900 !important',
          letterSpacing: '.06em',
          lineHeight: 1.1,
          marginBottom: theme.spacing(.1),
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        '& $productName': {
          display: '-webkit-box',
          fontSize: '.9rem',
          fontWeight: 800,
          letterSpacing: 0,
          lineHeight: 1.2,
          minHeight: '2.4em',
          overflow: 'hidden',
          textTransform: 'none',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
        },
        '& .card-product-title ul': {
          display: 'none',
        },
        '& $cardCommerce': {
          marginTop: theme.spacing(.7),
        },
        '& $quantityDiscountCardInfo': {
          marginTop: theme.spacing(.45),
          maxWidth: 'min(100%, 142px)',
          padding: theme.spacing(.34, .52),
        },
        '& $quantityDiscountCardEyebrow': {
          fontSize: '.5rem',
          padding: theme.spacing(.18, .4),
        },
        '& $quantityDiscountCardTitle': {
          fontSize: '.64rem',
        },
        '& $price': {
          justifyContent: 'center',
          marginTop: 0,
          textAlign: 'center',
          '& .MuiTypography-root': {
            fontSize: '.88rem',
            lineHeight: 1.2,
            textAlign: 'center',
          },
        },
        '& $deliverytimeDisplay': {
          display: 'none',
        },
        '& $listingGroupControls': {
          flexWrap: 'nowrap',
          gap: theme.spacing(.25),
          minHeight: 0,
          overflow: 'visible',
          padding: theme.spacing(.8, 0, 0),
        },
        '& $listingGroupItem': {
          height: 21,
          padding: 1,
          width: 21,
        },
        '& $listingGroupMore': {
          background: 'transparent',
          border: 0,
          cursor: 'pointer',
          flexBasis: 18,
          fontSize: '.68rem',
          height: 21,
          minWidth: 18,
          padding: 0,
        },
      },
      '@media (max-width: 767px)': {
        gridColumn: 'auto / span 1 !important',
        minWidth: 0,
        width: '100%',
      },
    },

    variantImageFrame: {
      position: 'relative',
      touchAction: 'pan-y',
      backgroundColor: '#fff',
      borderBottom: '1px solid rgba(15, 23, 42, 0.045)',
    },
    variantImageFrameSwipeable: {
      cursor: 'grab',
      userSelect: 'none',
    },
    variantImageFrameNativeCarousel: {
      // A descendant's pan-y would block the enclosing native horizontal scroller.
      touchAction: 'pan-x pan-y pinch-zoom',
    },
    variantSwipeHint: {
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.88)',
      border: '1px solid rgba(15, 23, 42, 0.08)',
      borderRadius: '50%',
      boxShadow: '0 6px 14px rgba(15, 23, 42, 0.12)',
      color: 'rgba(15, 23, 42, 0.72)',
      cursor: 'pointer',
      display: 'inline-flex',
      height: 30,
      justifyContent: 'center',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 30,
      zIndex: 1,
      '& svg': {
        pointerEvents: 'none',
      },
      '&:hover': {
        backgroundColor: '#fff',
        color: theme.palette.text.primary,
      },
    },
    variantSwipeHintDisabled: {
      cursor: 'default',
      opacity: .42,
      pointerEvents: 'auto',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.88)',
        color: 'rgba(15, 23, 42, 0.72)',
      },
    },
    variantSwipeHintLeft: {
      left: theme.spacing(1.15),
    },
    variantSwipeHintRight: {
      right: theme.spacing(1.15),
    },

    listingGroupControls: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(.75),
      minHeight: 38,
      padding: theme.spacing(.05, 2.25, 1.8),
    },
    listingGroupItem: {
      alignItems: 'center',
      background: '#fff',
      border: '1px solid rgba(15, 23, 42, 0.18)',
      borderRadius: '50%',
      boxSizing: 'border-box',
      color: theme.palette.text.secondary,
      cursor: 'pointer',
      display: 'inline-flex',
      flex: '0 0 auto',
      fontSize: '.72rem',
      fontWeight: 700,
      height: 28,
      justifyContent: 'center',
      lineHeight: 1,
      overflow: 'hidden',
      padding: 2,
      position: 'relative',
      width: 28,
      '& span': {
        alignItems: 'center',
        backgroundColor: '#f8fafc',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderRadius: '50%',
        display: 'inline-flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
      },
      '&:hover': {
        borderColor: 'rgba(15, 23, 42, 0.48)',
      },
    },
    listingGroupItemActive: {
      borderColor: theme.palette.text.primary,
      boxShadow: '0 0 0 2px rgba(15, 23, 42, 0.12)',
    },
    listingGroupMore: {
      alignItems: 'center',
      background: 'transparent',
      border: 0,
      color: theme.palette.text.secondary,
      cursor: 'pointer',
      display: 'inline-flex',
      flex: '0 0 30px',
      fontSize: '.9rem',
      fontWeight: 700,
      height: 28,
      justifyContent: 'center',
      lineHeight: 1,
      minWidth: 30,
      padding: 0,
      textAlign: 'center',
      '&:disabled': {
        cursor: 'default',
      },
    },
    listingGroupMoreBefore: {
      color: theme.palette.text.secondary,
    },
    listingGroupMoreHidden: {
      pointerEvents: 'none',
      visibility: 'hidden',
    },
    productBrand: {
      fontWeight: '900 !important',
      textAlign: 'center',
    },
    productName: {
      letterSpacing: 0,
    },

    noShaddow: {
      backgroundColor: 'transparent !important',
      border: '0 !important',
      borderRadius: 0,
      boxShadow: 'none',
    },

    // ----------------------------------------------
    // Produkt

    price: {
      display: 'grid',
      fontWeight: '800 !important',
      justifyContent: 'center',
      justifyItems: 'center',
      marginTop: theme.spacing(1.25),
      textAlign: 'center',
      width: '100%',
      '& .MuiTypography-root': {
        textAlign: 'center',
      },
    },

    cardCommerce: {
      marginTop: theme.spacing(1.15),
    },
    quantityDiscountCardInfo: {
      alignItems: 'center',
      backgroundColor: 'rgba(194, 0, 106, .07)',
      border: '1px solid rgba(194, 0, 106, .24)',
      borderRadius: 6,
      boxSizing: 'border-box',
      color: theme.palette.text.primary,
      display: 'inline-flex',
      flexDirection: 'column',
      gap: theme.spacing(.12),
      lineHeight: 1.15,
      margin: theme.spacing(.6, 'auto', 0),
      maxWidth: 190,
      padding: theme.spacing(.42, .7),
      textAlign: 'center',
      width: 'auto',
    },
    quantityDiscountCardEyebrow: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 999,
      color: theme.palette.primary.contrastText,
      display: 'inline-flex',
      fontSize: '.56rem',
      fontWeight: 900,
      letterSpacing: 0,
      lineHeight: 1,
      padding: theme.spacing(.22, .48),
      textTransform: 'uppercase',
    },
    quantityDiscountCardTitle: {
      color: theme.palette.primary.dark,
      display: '-webkit-box',
      fontSize: '.7rem',
      fontWeight: 900,
      letterSpacing: 0,
      lineHeight: 1.12,
      overflow: 'hidden',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
    },

    deliverytimeDisplay: {
      marginTop: theme.spacing(1.15),
      padding: 0,
      background: 'none',
      '& .MuiAlert-icon': {
        marginRight: theme.spacing(1),
      },
    },
    deliverytimeSuccess: {
      color: '#178f46',
      '& .MuiAlert-icon': {
        color: '#24b85a',
      },
    },
    deliverytimeInfo: {
      color: '#0f4f7f',
      '& .MuiAlert-icon': {
        color: '#1e9bff',
      },
    },
    deliverytimeWarning: {
      color: '#915500',
      '& .MuiAlert-icon': {
        color: '#f59b24',
      },
    },

    // ----------------------------------------------

  })
)

export default useStyles
